
import { Component, ModelSync, Vue } from 'nuxt-property-decorator'
import { NeoSwitch } from '@kodadot1/brick'

@Component({ components: { NeoSwitch } })
export default class ArweaveUploadSwitch extends Vue {
  @ModelSync('value', 'input', { type: Boolean })
  readonly checkedValue!: boolean
}
